<div class="max-w-[420px] w-full relative">
  <h5 class="pl-7 pt-7 pb-3 text-lg font-semibold">
    {{ config.title | translate }}
  </h5>

  <div class="folder-picker-tree-wrapper mx-7">
    <app-document-folder-tree-node [node]="root" [selectedNode]="selected" (nodeSelected)="select($event)" />
  </div>

  <div mat-dialog-actions class="mt-3 px-7 flex items-center justify-end gap-3" style="border-top: none">
    <button mat-stroked-button (click)="onCancel()" class="rounded-md h-[36px]!">
      {{ (config.cancelText ?? 'cancel') | translate }}
    </button>
    <button mat-flat-button color="primary" [disabled]="!selected" (click)="onConfirm()" class="rounded-md h-[36px]!">
      {{ (config.confirmText ?? 'select') | translate }}
    </button>
  </div>
</div>
